import React from "react"
import Page from "../components/page";
import RatingsGrid from "../components/ratingsgrid";
import { Link } from "gatsby";
import Seasons from "../../data/seasons.json";

const SEASON_CODE='2526';

const CurrentSeasonPage = (props) => {
  const season=Seasons.find(s=>s['code']===SEASON_CODE);
  const seasonName = season['name'];
  const pageTitle="Current Season College Basketball Ratings | CBB Ratings";
  const seoDescription=`Current-season NCAA men's college basketball ratings for ${seasonName}, data-driven team rankings updated throughout the season.`;
  const pageHeading="Current Season College Basketball Ratings";
  const subHeading="NCAA men's team ratings for the 2025–26 season";
  return (
    <Page
      location={props.location.href}
      pageTitle={pageTitle}
      seoDescription={seoDescription}
      pageHeading={pageHeading}
      subHeading={subHeading}
    >
      <p>
        These are the current-season NCAA men's college basketball ratings, updated daily as new games are played.
        <br/>
        See the <Link to="/methodology">rating methodology</Link> to understand how team strength and expected margins are calculated.
      </p>
      <RatingsGrid season={SEASON_CODE} />
    </Page>
    );
};
export default CurrentSeasonPage;